<template>
  <div class="flex items-end flex-col lg:flex-row lg:-mx-1">
    <div v-for="step in steps()" :key="step" class="flex-1 my-1 lg:mx-1 w-full">
      <div class="flex flex-row lg:flex-col justify-between items-center lg:items-start">
        <div class="text-xs">{{ style(step).title }}</div>
        <div :class="barClassFor(step)" class="rounded-sm lg:mt-1 h-2 w-24 md:w-48 lg:w-full"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { ORDER_STATUS } from '@/utils/order-status'

export default {
  props: {
    order   : Object,
    event   : Object,
    attendee: Object
  },
  data () {
    return {
      orderSteps   : [1, 2, 3, 4, 5, 6, 7],
      eventSteps   : [1, 2, 3, 4, 5, 6],
      attendeeSteps: [1, 2, 3, 4, 5, 6, 7]
    }
  },
  methods: {
    steps () {
      if (this.order) {
        return this.orderSteps
      } else if (this.event) {
        return this.eventSteps
      } else {
        return this.attendeeSteps
      }
    },
    style (step) {
      if (this.order) {
        return this.orderStatus(step)
      } else if (this.event) {
        return this.eventStatus(step)
      } else {
        return this.attendeeStatus(step)
      }
    },
    barClassFor (step) {
      switch (this.style(step).color) {
        case 'green':
          return 'bg-green-500'
        case 'yellow':
          return 'bg-yellow-500'
        case 'red':
          return 'bg-red-500'
        default:
          return 'bg-gray-500'
      }
    },
    orderStatus (step) {
      switch (step) {
        case 1: {
          let color = ''
          if (this.order.status !== ORDER_STATUS.ORDER_CREATED) {
            color = 'green'
          } else {
            color = 'gray'
          }
          return {
            title: 'Ready to Send',
            color: color
          }
        }
        case 2: {
          let color = ''
          switch (this.order.status) {
            case ORDER_STATUS.CANCELLED:
              color = 'red'
              break
            case ORDER_STATUS.SENT_TO_ATTENDEES:
            case ORDER_STATUS.ORDERS_PLACED:
            case ORDER_STATUS.BUILDING_BOXES:
            case ORDER_STATUS.BOXES_BUILT:
            case ORDER_STATUS.OUT_FOR_DELIVERY:
            case ORDER_STATUS.FULL_FILLED:
              color = 'green'
              break
            default:
              color = 'gray'
              break
          }
          return {
            title: 'Sent to Attendees',
            color: color
          }
        }
        case 3: {
          let color = ''
          switch (this.order.status) {
            case ORDER_STATUS.CANCELLED:
              color = 'red'
              break
            case ORDER_STATUS.SENT_TO_ATTENDEES: {
              const total = this.order.attendees_count
              const subOrders = this.order.sub_orders_total
              const completed = this.order.sub_orders_finished
              const cancelled = this.order.sub_orders_cancelled
              const inProgress = subOrders - completed - cancelled
              if (total !== 0 && total === completed) {
                color = 'green'
              } else if (inProgress > 0) {
                color = 'yellow'
              } else {
                color = 'gray'
              }
              break
            }
            case ORDER_STATUS.ORDERS_PLACED:
            case ORDER_STATUS.BUILDING_BOXES:
            case ORDER_STATUS.BOXES_BUILT:
            case ORDER_STATUS.OUT_FOR_DELIVERY:
            case ORDER_STATUS.FULL_FILLED:
              color = 'green'
              break
            default:
              color = 'gray'
              break
          }
          return {
            title: 'Ordering In Progress',
            color: color
          }
        }
        case 4: {
          let color = ''
          switch (this.order.status) {
            case ORDER_STATUS.ORDERS_PLACED:
            case ORDER_STATUS.BUILDING_BOXES:
            case ORDER_STATUS.BOXES_BUILT:
            case ORDER_STATUS.OUT_FOR_DELIVERY:
            case ORDER_STATUS.FULL_FILLED:
              color = 'green'
              break
            case ORDER_STATUS.CANCELLED:
              color = 'red'
              break
            default:
              color = 'gray'
              break
          }
          return {
            title: 'Orders Placed',
            color: color
          }
        }
        case 5: {
          let color = ''
          switch (this.order.status) {
            case ORDER_STATUS.CANCELLED:
              color = 'red'
              break
            case ORDER_STATUS.BUILDING_BOXES:
              color = 'yellow'
              break
            case ORDER_STATUS.BOXES_BUILT:
            case ORDER_STATUS.OUT_FOR_DELIVERY:
            case ORDER_STATUS.FULL_FILLED:
              color = 'green'
              break
            default:
              color = 'gray'
              break
          }
          return {
            title: 'Building Boxes',
            color: color
          }
        }
        case 6: {
          let color = ''
          switch (this.order.status) {
            case ORDER_STATUS.CANCELLED:
              color = 'red'
              break
            case ORDER_STATUS.OUT_FOR_DELIVERY:
            case ORDER_STATUS.FULL_FILLED:
              color = 'green'
              break
            default:
              color = 'gray'
              break
          }
          return {
            title: 'Out For Delivery',
            color: color
          }
        }
        case 7: {
          let color = ''
          switch (this.order.status) {
            case ORDER_STATUS.CANCELLED:
              color = 'red'
              break
            case ORDER_STATUS.FULL_FILLED:
              color = 'green'
              break
            default:
              color = 'gray'
              break
          }
          return {
            title: 'Order Fulfilled',
            color: color
          }
        }
      }
    },
    eventStatus (step) {

      switch (step) {
        case 1: {
          let color = ''
          if (this.event.invitation) {
            color = 'green'
          } else {
            color = 'gray'
          }
          return {
            title: 'Invitation Received',
            color: color
          }
        }
        case 2: {
          let color = ''
          if (this.event.invitation && this.event.invitation.open_at) {
            color = 'green'
          } else {
            color = 'gray'
          }
          return {
            title: 'I Looked At It',
            color: color
          }
        }
        case 3: {
          let color = ''
          if (this.event.sub_order) {
            if (this.event.is_ongoing) {
              switch (this.event.sub_order.status) {
                case ORDER_STATUS.CANCELLED:
                  color = 'red'
                  break
                case ORDER_STATUS.FINISHED:
                case ORDER_STATUS.BUILDING_BOXES:
                case ORDER_STATUS.BOXES_BUILT:
                case ORDER_STATUS.OUT_FOR_DELIVERY:
                case ORDER_STATUS.FULL_FILLED:
                  color = 'green'
                  break
                default:
                  color = 'yellow'
              }
            } else {
              if (this.event.sub_order.status === ORDER_STATUS.FINISHED) {
                color = 'green'
              } else {
                color = 'yellow'
              }
            }
          } else {
            color = 'gray'
          }
          return {
            title: 'Im working on it',
            color: color
          }
        }
        case 4: {
          let color = ''
          if (this.event.sub_order) {
            if (this.event.is_ongoing) {
              switch (this.event.sub_order.status) {
                case ORDER_STATUS.CANCELLED:
                  color = 'red'
                  break
                case ORDER_STATUS.FINISHED:
                case ORDER_STATUS.BUILDING_BOXES:
                case ORDER_STATUS.BOXES_BUILT:
                case ORDER_STATUS.OUT_FOR_DELIVERY:
                case ORDER_STATUS.FULL_FILLED:
                  color = 'green'
                  break
                default:
                  color = 'gray'
              }
            } else {
              if (this.event.sub_order.status === ORDER_STATUS.FINISHED) {
                color = 'green'
              } else {
                color = 'gray'
              }
            }
          } else {
            color = 'gray'
          }
          return {
            title: 'You Know What I Want',
            color: color
          }
        }
        case 5: {
          let color = ''
          if (this.event.is_ongoing) {
            switch (this.event.sub_order.status) {
              case ORDER_STATUS.CANCELLED:
                color = 'red'
                break
              case ORDER_STATUS.BUILDING_BOXES:
                color = 'yellow'
                break
              case ORDER_STATUS.BOXES_BUILT:
              case ORDER_STATUS.OUT_FOR_DELIVERY:
              case ORDER_STATUS.FULL_FILLED:
                color = 'green'
                break
              default:
                color = 'gray'
                break
            }
          } else {
            switch (this.event.status) {
              case ORDER_STATUS.CANCELLED:
                color = 'red'
                break
              case ORDER_STATUS.BUILDING_BOXES:
                color = 'yellow'
                break
              case ORDER_STATUS.BOXES_BUILT:
              case ORDER_STATUS.OUT_FOR_DELIVERY:
              case ORDER_STATUS.FULL_FILLED:
                color = 'green'
                break
              default:
                color = 'gray'
                break
            }
          }
          return {
            title: 'You\'re working on it',
            color: color
          }
        }
        case 6: {
          let color = ''
          if (this.event.is_ongoing) {
            if (this.event.sub_order.status === ORDER_STATUS.FULL_FILLED) {
              color = 'green'
            } else {
              color = 'gray'
            }
          } else {
            if (this.event.status === ORDER_STATUS.FULL_FILLED) {
              color = 'green'
            } else {
              color = 'gray'
            }
          }
          return {
            title: 'All good!',
            color: color
          }
        }
      }
    },
    attendeeStatus (step) {

      switch (step) {
        case 1: {
          let color = ''
          if (this.attendee.invitation) {
            color = 'green'
          } else {
            color = 'gray'
          }
          return {
            title: 'Sent to Attendee',
            color: color
          }
        }
        case 2: {
          let color = ''
          if (this.attendee.invitation && this.attendee.invitation.open_at) {
            color = 'green'
          } else {
            color = 'gray'
          }
          return {
            title: 'Viewed',
            color: color
          }
        }
        case 3: {
          let color = ''
          console.log('STEP: ', this.attendee.sub_order, this.attendee.is_ongoing)
          if (this.attendee.sub_order) {
            if (this.attendee.is_ongoing) {
              switch (this.attendee.sub_order.status) {
                case ORDER_STATUS.CANCELLED:
                  color = 'red'
                  break
                case ORDER_STATUS.FINISHED:
                case ORDER_STATUS.BUILDING_BOXES:
                case ORDER_STATUS.BOXES_BUILT:
                case ORDER_STATUS.OUT_FOR_DELIVERY:
                case ORDER_STATUS.FULL_FILLED:
                  color = 'green'
                  break
                default:
                  color = 'yellow'
              }
            } else {
              if (this.attendee.sub_order.status === ORDER_STATUS.FINISHED) {
                color = 'green'
              } else {
                color = 'yellow'
              }
            }
          } else {
            color = 'gray'
          }
          if (this.attendee.sub_order.status === ORDER_STATUS.CANCELLED) {
            return {
              title: 'Ordering Cancelled',
              color: 'red'
            }
          }

          return {
            title: 'Ordering In Progress',
            color: color
          }
        }
        case 4: {
          let color = ''
          if (this.attendee.sub_order) {
            if (this.attendee.is_ongoing) {
              switch (this.attendee.sub_order.status) {
                case ORDER_STATUS.CANCELLED:
                  color = 'red'
                  break
                case ORDER_STATUS.FINISHED:
                case ORDER_STATUS.BUILDING_BOXES:
                case ORDER_STATUS.BOXES_BUILT:
                case ORDER_STATUS.OUT_FOR_DELIVERY:
                case ORDER_STATUS.FULL_FILLED:
                  color = 'green'
                  break
                default:
                  color = 'gray'
              }
            } else {
              if (this.attendee.sub_order.status === ORDER_STATUS.FINISHED) {
                color = 'green'
              } else {
                color = 'gray'
              }
            }
          } else {
            color = 'gray'
          }
          return {
            title: 'Order Placed',
            color: color
          }
        }
        case 5: {
          let color = ''
          if (this.attendee.is_ongoing) {
            if (this.attendee.sub_order) {
              switch (this.attendee.sub_order.status) {
                case ORDER_STATUS.CANCELLED:
                  color = 'red'
                  break
                case ORDER_STATUS.BUILDING_BOXES:
                  color = 'yellow'
                  break
                case ORDER_STATUS.BOXES_BUILT:
                case ORDER_STATUS.OUT_FOR_DELIVERY:
                case ORDER_STATUS.FULL_FILLED:
                  color = 'green'
                  break
                default:
                  color = 'gray'
                  break
              }
            } else {
              color = 'gray'
            }
          } else {
            if (this.attendee.sub_order) {
              switch (this.attendee.status) {
                case ORDER_STATUS.CANCELLED:
                  color = 'red'
                  break
                case ORDER_STATUS.BUILDING_BOXES:
                  color = 'yellow'
                  break
                case ORDER_STATUS.BOXES_BUILT:
                case ORDER_STATUS.OUT_FOR_DELIVERY:
                case ORDER_STATUS.FULL_FILLED:
                  color = 'green'
                  break
                default:
                  color = 'gray'
                  break
              }
            } else {
              color = 'gray'
            }
          }
          return {
            title: 'Building Box',
            color: color
          }
        }
        case 6: {
          let color = ''
          if (this.attendee.is_ongoing) {
            if (this.attendee.sub_order) {
              switch (this.attendee.sub_order.status) {
                case ORDER_STATUS.CANCELLED:
                  color = 'red'
                  break
                case ORDER_STATUS.OUT_FOR_DELIVERY:
                case ORDER_STATUS.FULL_FILLED:
                  color = 'green'
                  break
                default:
                  color = 'gray'
                  break
              }
            } else {
              color = 'gray'
            }
          } else {
            if (this.attendee.sub_order) {
              switch (this.attendee.status) {
                case ORDER_STATUS.OUT_FOR_DELIVERY:
                case ORDER_STATUS.FULL_FILLED:
                  color = 'green'
                  break
                default:
                  color = 'gray'
                  break
              }
            } else {
              color = 'gray'
            }
          }
          return {
            title: 'Out For Delivery',
            color: color
          }
        }
        case 7: {
          let color = ''
          if (this.attendee.is_ongoing) {
            if (this.attendee.sub_order && this.attendee.sub_order.status === ORDER_STATUS.FULL_FILLED) {
              color = 'green'
            } else {
              color = 'gray'
            }
          } else {
            if (this.attendee.sub_order) {
              if (this.attendee.status === ORDER_STATUS.FULL_FILLED) {
                color = 'green'
              } else {
                color = 'gray'
              }
            } else {
              color = 'gray'
            }
          }
          return {
            title: 'Order Fulfilled',
            color: color
          }
        }
      }
    },
  }
}
</script>